import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 *
 * 出差总结报告
 */
export class ApplyEvectionIsumApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-evection-isum'
    }




}
